import BN from 'big.js'

const USD_FORMATTER = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})

export default {
  
  addressEquals(addr1,addr2) {
    return addr1.toLowerCase()==addr2.toLowerCase()
  },

  shortenAddress(a) {
    if(a==null) return '?';
    a = a.toUpperCase();
    return '0×'+a.substr(2,4)+'…'+a.substr(-4,4);
  },

  shortenAddressHtml(a) {
    if(a==null) return '?';
    a = a.toUpperCase();
    return `<span class=""><span class="text-gray-400 text-sm">0x</span>${a.substr(2,4)}<span class="text-gray-400 text-sm">…</span>${a.substr(-4,4)}</span>`;
  },

  address(a) {
    if(a==null) return '?';
    a = a.toUpperCase();
    return `<span class="">0x${a.substr(2)}</span>`
  },

  addressHtml(a) {
    if(a==null) return '?';
    a = a.toUpperCase();
    return `<span class=""><span class="text-gray-400 text-sm">0x</span>${a.substr(2)}</span>`;
  },

  numberCommas(x) {
    if(x==null) return '?';
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },

  numberCommasHtml(x) {
    let str = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, `,`);
    return str.replaceAll(",",'<span class="text-gray-400">,</span>');
  },

  // Positive only
  formatToken(b) {
    if(b==null || b==0) return "0";

    let n;
    if(b>1) n = b.toFixed(2)
    else {
      let str = b.toFixed(18).split('.')[1]
      let match = str.match(/^0+/)
      let level = match ? match[0].length : 0
      n = str.substr(0,level+3)
    }
    return n
  },

  // Positive only
  formatTokenLong(b,f=2) {
    if(b==null || b==0) return "0";

    let n;
    if(b>=1) n = b.toLocaleString('en-US', {minimumFractionDigits: f})
    else {
      let str = b.toFixed(18).split('.')[1]
      let match = str.match(/^0+/)
      let level = match ? match[0].length : 0
      n = str.substr(0,level+3).replace(/[0]+$/, "")
      if(n.length<f) n += Array(f-n.length).fill(0)
      n = '0.' + n
    }
    return n
  },

  formatBalance(b) {
    if(b==null) return "0";

    let n;
    if(b.gt(BN(1000000))) n = b.toFixed(0);
    else if(b.gt(BN(100000))) n = b.toFixed(1);
    else if(b.gt(BN(10000))) n = b.toFixed(2);
    else if(b.gt(BN(1000))) n = b.toFixed(3);
    else if(b.gt(BN(100))) n = b.toFixed(4);
    else if(b.gt(BN(100))) n = b.toFixed(5);
    else if(b.gt(BN(10))) n = b.toFixed(6);
    else if(b.gt(BN(1))) n = b.toFixed(7);
    else if(b.gt(BN(0.1))) n = b.toFixed(8);
    else if(b.gt(BN(0.01))) n = b.toFixed(9);
    else if(b.gt(BN(0.001))) n = b.toFixed(10);
    else if(b.gt(BN(0.001))) n = b.toFixed(11);
    else if(b.gt(BN(0.0001))) n = b.toFixed(12);
    else if(b.gt(BN(0.0001))) n = b.toFixed(13);
    else if(b.gt(BN(0.00001))) n = b.toFixed(14);
    else if(b.gt(BN(0.000001))) n = b.toFixed(15);
    else if(b.gt(BN(0.0000001))) n = b.toFixed(16);
    else if(b.gt(BN(0.00000001))) n = b.toFixed(17);
    else n = b.toFixed(18);

    return n.replace(/\.?0+$/,"");
  },
  
  formatBalanceHtml(b) {
    if(b==null) return "<span class='text-gray-400'>N/A</span>";
    else if(b.eq(0)) return "<span class='text-gray-400'>0</span>";

    if(b.lt(1)) { // Less than 1, make inital '0.' gray
      let arr = this.formatBalance(b).split('.');
      if(arr.length==2) return `<span class="text-gray-400 text-sm">0.</span>${arr[1]}`;
      else return arr[0];
    }
    else { // Greater than 1, make all past decimal gray
      let arr = this.formatBalance(b).split('.');
      if(arr.length==2) return `${arr[0]}<span class="text-gray-400 text-sm">.${arr[1]}</span>`;
      else return arr[0];
    }
  },

  formatBalanceFixed(b, decimals) {
    if(b==null) return "0";
    return b.toFixed(decimals).replace(/\.?0+$/,""); // Remove trailing zeroes
  },
  
  formatCurrencyHtml(n) {
    if(n==null||n.eq(0)) return "<span class='text-gray-400'>N/A</span>";
    else if(n.lt(0.01)) return "<span class='text-gray-400 text-sm'>&lt;$0.</span>01";
    else if(n.gt(1)) {
      let arr = n.toFixed(2).split('.');
      return `<span class="text-gray-400 text-sm">$</span>${this.numberCommasHtml(arr[0])}<span class="text-gray-400 text-sm">.${arr[1]}</span>`;
    }
    else {
      let arr = n.toFixed(2).split('.');
      return `<span class="text-gray-400 text-sm">$0.</span>${arr[1]}`;
    }
  },

  formatPercentHtml(n,total,fixed) {
    if(n==null || n==0) return `<span class="text-gray-400">0<span class="text-sm">%</span></span>`
    else if(n.eq(total)) return `100<span class="text-sm">%</span>`

    let pct = n.div(total).mul(100).toFixed(fixed);
    return `${pct}<span class='text-gray-400 text-sm' style='margin-left:2px'>%</span>`
  },

  formatChanceHtml(n,total) {
    if(n==null || n==0) return `<span class="text-gray-400">0<span class="text-sm">%</span></span>`;
    else if(n.eq(total)) return `100<span class="text-sm">%</span>`;

    let pct = n.div(total).mul(100).toFixed(0);
    if(pct=="100") return `<span class="text-gray-400 text-sm">&gt;</span>99<span class="text-sm">%</span>`;
    else if(pct>=1) return `${pct}<span class='text-gray-400 text-sm'>%</span>`;
    return `<span class='text-gray-400 text-sm'>&lt;</span>1<span class='text-gray-400 text-sm'>%</span>`;
  },

  formatDateHtml(d) {
    if(d==null) return `<span class="text-gray-400">N/A</span>`;
    let a = d.format('M/D/YYYY').replaceAll('/',`<span class="text-gray-400 text-sm">/</span>`);
    return `${a} <span class="text-gray-400 text-sm">${d.format('h:mm A')}</span>`;
  },

  abbreviateNumber(num, fixed) {
    if (num === null) { return null; } // terminate early
    if (num === 0) { return '0'; } // terminate early
    fixed = (!fixed || fixed < 0) ? 0 : fixed; // number of decimal places to show
    var b = (num).toPrecision(2).split("e"), // get power
        k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 17) / 3), // floor at decimals, ceiling at trillions
        c = k < 1 ? num.toFixed(0 + fixed) : (num / Math.pow(10, k * 3) ).toFixed(1 + fixed), // divide by power
        d = c < 0 ? c : Math.abs(c), // enforce -0 is 0
        e = d.toFixed(fixed) + ['', 'K', 'M', 'B', 'T', 'Q'][k]; // append power
    return e;
  },

  abbreviateNumberHtml(num, fixed) {
    if (num === null) { return null; } // terminate early
    if (num === 0) { return '0'; } // terminate early
    fixed = (!fixed || fixed < 0) ? 0 : fixed; // number of decimal places to show
    var b = (num).toPrecision(2).split("e"), // get power
        k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 17) / 3), // floor at decimals, ceiling at trillions
        c = k < 1 ? num.toFixed(0 + fixed) : (num / Math.pow(10, k * 3) ).toFixed(1 + fixed), // divide by power
        d = c < 0 ? c : Math.abs(c) // enforce -0 is 0
    
    let metric = [null, 'K', 'M', 'B', 'T', 'Q'][k]
    let str = `${d.toFixed(fixed)}`
    if(metric!=null) str += `<span class="text-gray-400" style="margin-left:2px">${metric}</span>`
    return str
  },

  formatUSD(x) {
    return USD_FORMATTER.format(x)
  }

}
